import React, { useEffect, useState } from 'react'


interface CheckboxProps {
	label: string
	defaultChecked?: boolean
	onChange?: (checked: boolean) => void
	className?: (state: any) => string
	description?: string | null
	disabled?: boolean
}


const Checkbox: React.FC<CheckboxProps> = ({
	label,
	defaultChecked = false,
	onChange,
	className,
	description,
	disabled = false,
}) => {
	const [checked, setChecked] = useState(false)

	const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		const isChecked = event.target.checked
		setChecked(isChecked)
		onChange?.(isChecked)
	}

	const stopPropagation = (e: React.MouseEvent) => {
		e.stopPropagation()
	}
	useEffect(() => {
		if (defaultChecked !== checked && defaultChecked !== undefined) {
			setChecked(defaultChecked)
		}
		if (defaultChecked === null || defaultChecked === undefined) {
			setChecked(false)
		}
	}, [defaultChecked])

	/*const sizeClasses = {
		sm: 'h-[37px]  gap-sm px-sm py-[0px] text-title-md',
		md: 'h-[44px]  gap-sm px-md py-[0px] text-title-md',
		lg: 'h-[50px]  gap-md px-lg py-[0px] text-title-lg',
	}*/

	return (
		<label
			tabIndex={0}
			className={` select-none flex items-center ${!disabled ? 'cursor-pointer' : ''} group gap-sm flex-row outline-0 ${
				className && className(checked)
			}`}
			onClick={stopPropagation}
		>
			<input
				type="checkbox"
				className="form-checkbox hidden"
				checked={checked}
				onChange={handleCheckboxChange}
				disabled={disabled}
			/>
			<div
				className={` select-none w-[18px] h-[18px] flex item-center justify-center overflow-hidden  rounded-sm shadow-xs border  ${
					!disabled ? ' group-hover:border-primary-500 group-active:shadow-focus' : ''
				} transition-all   ${
					checked
						? `   delay-0 ${
							!disabled
								? 'group-hover:bg-primary-500 group-hover:border-primary-700 bg-primary-500 border-primary-700'
								: ' bg-gray-300 border-gray-400'
						}`
						: ' bg-white border-gray-300  delay-50'
				}`}
			>
			<span
				className={
					`select-none font-icon-solid text-white relative top-[-1px] transition-all text-shadow-xs text-[12px] ` +
					`${!checked ? 'scale-300 top-[-10px] opacity-0' : 'scale-100 opacity-100 delay-150'}`
				}
			>
				
			</span>
			</div>
			<span
				className={` ${
					!disabled ? 'group-hover:text-gray-900 text-gray-900' : ' text-gray-400'
				} transition-all text-text-md flex flex-row gap-xs whitespace-nowrap`}
			>
        {label}
				{description && <span className={'text-gray-400'}>{description}</span>}
      </span>
		</label>
	)
}

export default Checkbox
